
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'MyProjetos',
  components: {},
  data() {
    return {
      ThemosVagas: require('@/assets/img/Themosvagas.png'),
      ApiWhatsapp: require('@/assets/img/ApiWhatsapp.png'),
      RastreamentoWeb: require('@/assets/img/RastreadorWeb.png'),
      RastreamentoBack: require('@/assets/img/RastreadorBack.png'),
      Portfolio: require('@/assets/img/Portfolio.png'),
      PortfolioBack: require('@/assets/img/PortfolioBack.png'),
    }
  },
});
